import { IAuthState } from "./auth/types";
import { DataSourceMapState } from "./datasource/types";
import { IEnumsState } from "./enums/types";
import { IFetchingState } from "./fetching/types";
import { Ii18nState } from "./i18n/types";
import { ThemeState } from "./theme/types";

/**
 * Reprezentuje strukturu redux stavu sloužící core modulům.
 */
export interface ICoreState {
    readonly auth: IAuthState;
    readonly fetching: IFetchingState;
    readonly i18n: Ii18nState;
    readonly theme: ThemeState;
    readonly dataSource: DataSourceMapState;
    readonly enums: IEnumsState;
}
